// extracted by mini-css-extract-plugin
export var container = "_ns-0";
export var dotAnimation = "_ns-2";
export var dotsLoading = "_ns-1";